import { Box, Grid, Stack, Typography,  } from '@mui/material'

import HourBar from "./hourBar";
import custom from '../../../styles/mui/szVariables.json'

export default function Rates({ rates }: any) {
    if(Array.isArray(rates?.hours)) {
        rates.hours = rates?.hours?.sort((a:any,b:any)=>a.idx-b.idx)
    }
    return (
      <Grid container direction="column" 
            display="flex" justifyContent={"center"}
            p={custom.spacing.md}>
        <Grid item xs maxWidth="100%">
            <Box display="flex"
                justifyContent={"center"}>
                {rates?.hours?.map((h:any)=>(
                    <HourBar data={h} />
                ))}
            </Box>
        </Grid>
        <Grid item maxWidth="100%" mt={custom.spacing.xxs}>
            <Stack direction="row" justifyContent={"space-between"}>  
                <Box>
                    <Box height="12px" width="12px" sx={{ 
                            backgroundColor: 'sz.colors.orange200',
                            mr: custom.spacing.xxxs,
                            borderRadius: custom.corners2,
                            display: 'inline-block'
                        }}/> 
                    <Typography variant='szBody.Regular.xSmall' 
                        id='offPeakText' 
                        display='inline-block'
                        pr={custom.spacing.xxxs} >   
                        {rates?.offPeak?.label}
                    </Typography>
                    <Typography variant='szBody.Bold.xSmall' 
                        id='offPeakValue'
                        display='inline-block'>
                        {rates.unit}{rates?.offPeak?.rateText}
                    </Typography>
                </Box> 
                <Box>
                    <Box height="12px" width="12px"
                        sx={{ 
                            backgroundColor: 'sz.colors.orange300',
                            mr: custom.spacing.xxxs,
                            borderRadius: custom.corners2,
                            display: 'inline-block'
                        }}/> 
                    <Typography variant='szBody.Regular.xSmall' 
                        id='shoulderText' 
                        display='inline-block'
                        pr={custom.spacing.xxxs}>   
                        {rates?.shoulder?.label}
                    </Typography>
                    <Typography variant='szBody.Bold.xSmall' 
                        id='shoulderValue'
                        display='inline-block'>
                        {rates.unit}{rates?.shoulder?.rateText}
                    </Typography>
                </Box> 
                {rates.peak ? 
                    <Box>
                        <Box height="12px" width="12px" sx={{ 
                                backgroundColor: 'sz.colors.orange400',
                                mr: custom.spacing.xxxs,
                                borderRadius: custom.corners2,
                                display: 'inline-block'
                            }}/> 
                        <Typography variant='szBody.Regular.xSmall' 
                            id='peakText' 
                            display='inline-block'
                            pr={custom.spacing.xxxs}>   
                            {rates?.peak?.label}
                        </Typography>
                        <Typography variant='szBody.Bold.xSmall' 
                            id='peakValue' 
                            display='inline-block'>
                            {rates.unit}{rates?.peak?.rateText}
                        </Typography>
                    </Box>
                :<></>}
            </Stack>
        </Grid>
        <Grid item mt={custom.spacing.sm} 
            maxWidth="100%"
            justifyContent={"center"}>
            <Box display="flex"  
                justifyContent={"center"}
                alignContent={"center"} 
                width="100%">
                <Typography 
                    textAlign={"center"}
                    variant="szBody.Regular.xSmall"
                    color="text.secondary">
                    {rates.notes}
                </Typography>
            </Box>    
        </Grid>
      </Grid>
    )
}

